import { Menu, MenuList } from '@lokalise/louis';

import { DropdownContent } from '../../../../pages/ProjectsList/components/NavigationBlock';
import type { DropdownItem, NavigationItem } from '../../../../types/navigation';
import ProjectNavigationItem from './ProjectNavigationItem';
import { Container, NavigationTab, NavigationTabList } from './styles';

interface ProjectNavigationProps {
    navigation: NavigationItem[];
    activeItem: string;
}

const checkAnyVisible = (dropdown: DropdownItem[][] | undefined) =>
    dropdown?.some((section) => section.some((item) => item.visible));

const checkVisibility = (navigationItem: NavigationItem) => {
    if (!navigationItem.visible) {
        return false;
    }

    if (!navigationItem.dropdown) {
        return true;
    }

    return checkAnyVisible(navigationItem.dropdown);
};

const ProjectNavigation = ({ navigation, activeItem }: ProjectNavigationProps) => (
    <Container aria-label="Project">
        <NavigationTabList aria-orientation="horizontal">
            {navigation.filter(checkVisibility).map((item) => {
                if (item.dropdown) {
                    return (
                        <NavigationTab
                            key={item.key}
                            data-testid={item.key}
                            aria-selected={item.isActive && item.isActive(activeItem)}
                        >
                            <Menu
                                menuButton={({ opened }) => (
                                    <ProjectNavigationItem
                                        label={item.label}
                                        disabled={item.disabled}
                                        active={opened}
                                    />
                                )}
                            >
                                <MenuList>
                                    <DropdownContent items={item.dropdown} />
                                </MenuList>
                            </Menu>
                        </NavigationTab>
                    );
                }

                return (
                    <NavigationTab
                        key={item.key}
                        data-testid={item.key}
                        aria-selected={item.isActive && item.isActive(activeItem)}
                    >
                        <ProjectNavigationItem
                            label={item.label}
                            href={item.link}
                            onClick={item.onClick}
                            disabled={item.disabled}
                            badge={item.badge}
                            novel={item.novel}
                        />
                    </NavigationTab>
                );
            })}
        </NavigationTabList>
    </Container>
);

export default ProjectNavigation;
